import type { FaireProductEntity } from "../../entity_types/product";

export const p_yxbgbmypsx: FaireProductEntity = {
  token: "p_yxbgbmypsx",
  type: "product",
  name: "Agni Bandha – Copper Frequency Bracelet for Vitality",
  brandToken: "b_cr4nybygzm",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/4f3d5115024e1735a60c1dd643d88e575c35753259330eb07f64f739afda5716.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7801f3850d27a2b1ef9b1a820003526abbfd54315ded262ea8135acc536b1ec0.jpeg",
    "https://cdn.faire.com/fastly/d61dbcd41c564140738f352abb727ff22861cbd79d42c5d63b061fe643da3a6f.jpeg",
    "https://cdn.faire.com/fastly/f4822187b22e6c4646d8c90c954540b3bedca3cfc75b4253959cd9b5e103c96a.jpeg",
    "https://cdn.faire.com/fastly/9c657be6aadfeff0eeec316b0fa4c2672172ea0a7ed8bc37887db0f1babac8e4.jpeg",
    "https://cdn.faire.com/fastly/6f4aa6d779a79de88b21e47d11650fc1f786bdb1fe2c45f084b8b15860d6e304.jpeg",
    "https://cdn.faire.com/fastly/906a574d867f20db216fd72b6d25445d4735c04df21651c72d1dcd98016e2852.jpeg",
    "https://cdn.faire.com/fastly/baf72f070bf0e6df2c2d1ea8cc1e44e49e7c0a29efb8544643ae90fb5b7e7579.jpeg",
    "https://cdn.faire.com/fastly/7ac56f5a956f3441722f04db5a4302370c45304eceb08c6c02aa171d8bd535f2.jpeg",
    "https://cdn.faire.com/fastly/f04405683c447565f43bdfd12794c16203b38c71bc91c3719eddfa1986029df9.jpeg"
  ],
  priceDollars: 30.49,
  description: "Handcrafted from pure Indian copper and charged with intentional frequencies, Reiki, and energy work, the Agni Bandha bracelet supports protection, vitality, and balance. Inspired by Agni, god of fire, this wearable spiritual tool empowers strength and transformation.\n\nHandcrafted from ethically sourced pure Indian copper\n\nCharged with Reiki, vibrational tuning & frequencies\n\nInspired by Agni, Hindu god of fire & transformation\n\nSupports energetic balance, protection, and vitality\n\nCopper naturally patinas over time—symbolizing growth\n\nWear daily for continuous grounding & manifestation support\n\nShelf-ready, giftable packaging—perfect for wellness & metaphysical retailers",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:48.555Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
